import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"
import { showNotification } from "../helpers"

export default class extends Controller {
  static targets = ["codeInput", "phoneInput", "sendButton"]
  static values = {
    method: String,
    url: String,
    userUrl: String,
    sendCodeError: String,
    savePhoneError: String
  }

  connect() {
    const section = this.element.parentNode
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutationRecord) => {
        const targetElement = mutationRecord.target
        if (targetElement.classList.contains("hidden")) {
          const btn = this._submitButton
          if (btn) btn.disabled = true
          this.codeInputTarget.value = ""
        }
      })
    })

    this.observer.observe(section, {
      attributes: true,
      attributeFilter: ["class"],
    })
  }

  sendCode() {
    if (!this.methodValue || !this.urlValue) return

    Rails.ajax({
      type: "POST",
      url: this.urlValue,
      data: new URLSearchParams({ method: this.methodValue }).toString(),
      success: (data) => {
        this.triggerResendCooldown()
        showNotification(data.message)

        if (data.sended && this.hasCodeInputTarget) {
          this.codeInputTarget.disabled = false
          this.codeInputTarget.removeAttribute("title")
        }
      },
      error: (xhr) => {
        this.triggerResendCooldown()

        let message = this.sendCodeErrorValue
        try {
          const data = JSON.parse(xhr.responseText)
          if (data.message) message = data.message
        } catch {}

        showNotification(message)
      }
    })
  }

  triggerResendCooldown() {
    if (this.hasSendButtonTarget) {
      this.dispatch("cooldown", { target: this.sendButtonTarget })
    }
  }

  enableSaveButton(event) {
    if (event.currentTarget.value.length > 0) {
      const button = this._submitButton
      if (button) button.disabled = false
    }
  }

  validatePhone(event) {
    if (event.params.extendedFunc) {
      validate_phone()
      return
    }

    const parentDiv = this.phoneInputTarget.closest("div")

    if (this.isPhoneValid()) {
      parentDiv.classList.remove("field_with_errors")
      this.sendButtonTarget.disabled = false
    } else {
      parentDiv.classList.add("field_with_errors")
      this.sendButtonTarget.disabled = true
    }
  }

  saveAndSendCode() {
    const phone = this.normalizePhone()
    Rails.ajax({
      type: "POST",
      url: this.userUrlValue,
      data: new URLSearchParams({
        _method: "patch",
        "user[phone]": phone
      }).toString(),
      contentType: "application/json",
      success: (data) => {
        showNotification(data.message)
        this.sendCode()
      },
      error: (xhr) => {
        this.triggerResendCooldown()
        let message = this.savePhoneErrorValue
        try {
          const data = JSON.parse(xhr.responseText)
          if (data.message) message = data.message
        } catch {}
        showNotification(message)
      }
    })
  }

  get _submitButton() {
    return document.getElementById("two_step_verification_submit")
  }

  disconnect() {
    this.observer.disconnect()
  }

  isPhoneValid() {
    if (!this.hasPhoneInputTarget) return false
    const value = this.phoneInputTarget.value
    return /^\d{3}-\d{3}-\d{3}$/.test(value) && value[0] !== "0"
  }

  normalizePhone() {
    return "+48 " + this.phoneInputTarget.value.match(/\d/g).join("")
  }
}
